import React, { SVGProps } from 'react';

export const ChevronDownIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 8,
  height = 5,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 8 5"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.330314 1.86173L3.21591 4.68155C3.65042 5.10615 4.35232 5.10615 4.78684 4.68155L7.67243 1.86173C8.37434 1.17583 7.87298 0 6.8814 0H1.11021C0.118629 0 -0.371588 1.17583 0.330314 1.86173Z"
        fill="#C6C6C6"
      />
    </svg>
  );
};
